import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function getHiddenGems({ maxOwnership = 15, minMinutes = 450, poolSize = 60, topN = 30 } = {}) {
    const r = await axios.get(`${API}/hidden-gems`, {
        params: {
            max_ownership: maxOwnership,
            min_minutes: minMinutes,
            pool_size: poolSize,
            top_n: topN,
        },
    });
    return r.data;
}
